module.exports = __webpack_public_path__ + "static/media/mobile-icons-buttons-page-navigation-right-arrow-default.b08aeb44.svg";